import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";

export default function Dashboard() {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const [results, setResults] = useState([]);
  const suffix = lang === "hi" ? "Hi" : lang === "ta" ? "Ta" : "";

  useEffect(() => {
    api.get("/api/results/my").then((r) => setResults(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-4 py-14" data-testid="dashboard-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-4xl font-semibold" data-testid="dashboard-title">{t("dash.title")}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{user?.name} · {t("dash.sub")}</p>
        </div>
        <Link to="/assessment">
          <Button className="rounded-full" data-testid="dashboard-new-assessment"><Plus className="mr-1 h-4 w-4" />{t("dash.new")}</Button>
        </Link>
      </div>

      <h2 className="font-display mt-12 text-2xl font-semibold">{t("dash.results")}</h2>
      {results.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground" data-testid="dashboard-empty">
          {t("dash.empty")}
        </div>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-testid="dashboard-results-list">
          {results.map((r) => (
            <Link key={r.id} to={`/results/${r.id}`} className="group rounded-2xl border border-border bg-card p-6 transition-shadow hover:shadow-lg" data-testid={`result-card-${r.id}`}>
              <div className="flex items-center justify-between">
                <span className="font-display text-xl font-semibold" style={{ color: r.archetypeColor || "inherit" }}>
                  {r[`archetypeName${suffix}`] || r.archetypeName || r.type || "—"}
                </span>
                <span className="text-xs text-muted-foreground">{r.createdAt ? new Date(r.createdAt).toLocaleDateString() : ""}</span>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-xs uppercase tracking-wide text-muted-foreground">{r.engine === "edviaiq" ? "EdviaIQ" : "Classic"}</span>
                <span className="text-sm font-medium text-primary group-hover:underline">{t("dash.view")} →</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
